import { Space } from '../../../../../components/core-v2'
import TradeEventDisplay from '../../../../../components/core-v2/organisms/trade-event-display/trade-event-display'
import { SubmitStepState } from '../state/submit-slice'

export type TradeSubmitStatelessProps = {
  state: SubmitStepState
}

const TradeSubmitStateless = ({ state }: TradeSubmitStatelessProps) => (
  <Space>
    {state.approvalEvents.map(approvalEvent => (
      <TradeEventDisplay key={approvalEvent.userId} {...approvalEvent} />
    ))}
  </Space>
)

export default TradeSubmitStateless
